import { volumeApiFetch } from "@/lib/volume-api";
import { z } from "zod/v4";

export const OptimusBeneficiariesResponseSchema = z.array(
  z.object({
    optimusBeneficiaryId: z.string(),
    optimusExternalCustomerId: z.string(),
    firstNames: z.string(),
    accountType: z.enum(["SCAN", "IBAN"]),
    accountNumber: z.string().nullable(),
    sortCode: z.string().nullable(),
    iban: z.string().nullable(),
    status: z.string().nullable(),
  }),
);
export type FetchBeneficiariesResponse = z.infer<
  typeof OptimusBeneficiariesResponseSchema
>;

export async function fetchOptimusBeneficiariesForCustomer({
  customerId,
  accessToken,
}: {
  customerId: string;
  accessToken: string;
}) {
  const response = await volumeApiFetch({
    accessToken,
    endpoint: `providers/optimus/customers/${customerId}/beneficiaries`,
    method: "GET",
  });

  if (response.status === 401 || response.status === 403) {
    throw new Error("Unauthorized");
  }
  if (!response.ok) {
    throw new Error("Failed to fetch optimus beneficiaries");
  }
  const json = await response.json();
  return OptimusBeneficiariesResponseSchema.parse(json);
}
